import axios from 'axios'
import { userService } from '../services'

export function getInstance() {
  let token

  if (localStorage) {
    const storage = localStorage.getItem('amdreward_user')
    token = storage ? JSON.parse(storage).token : null
  }

  const instance = axios.create({
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
    },
  })

  // Transform response
  instance.interceptors.response.use(
    response => response.data,
    error => {
      // If not authorized, move user to login
      if (
        error.response &&
        error.response.status === 401 &&
        !window.location.pathname.includes('login')
      ) {
        window.location.replace('/login')
        userService.removeSessionStorage()
      }
      return Promise.reject({
        errors: error.response.data,
        statusText: error.response.statusText,
        status: error.response.status,
      })
    }
  )
  return instance
}

export default {
  get: (...args) => getInstance().get(...args),
  post: (...args) => getInstance().post(...args),
  put: (...args) => getInstance().put(...args),
  delete: (...args) => getInstance().delete(...args),
}
